import { AgentAnalytics } from "../../components/agents/AgentAnalytics";
import { TabPanel } from "../../components/base";
import { agentOverviewOverlay } from "../../components/onboarding/coachOverlays";
import { useCoachOverlay } from "../../components/onboarding/useCoachOverlay";

export const AgentDetailsPage = () => {
  useCoachOverlay(agentOverviewOverlay);

  return (
    <TabPanel className="!space-y-0 !p-0">
      <AgentAnalytics />
    </TabPanel>
  );
};
